import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=67a5fd5a&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=67a5fd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5fd5a",
  null
  
)

export default component.exports